module.exports = __webpack_public_path__ + "bcae3c0aebf38d30c0d7e72f12b1fce5.svg";